import { render } from "./leftnav.vue?vue&type=template&id=67b238ee&scoped=true"
import script from "./leftnav.vue?vue&type=script&lang=js"
export * from "./leftnav.vue?vue&type=script&lang=js"

import "./leftnav.vue?vue&type=style&index=0&id=67b238ee&lang=less&scoped=true"

import exportComponent from "E:\\ekt.pro.git\\new-ekt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b238ee"]])

export default __exports__